const getWarehouseLabelFromConfiguration = (user, customerWarehouseConfiguration) => {
    if (user?.role === 'SHIPPER' && customerWarehouseConfiguration?.warehouseNameForShipper) {
        return customerWarehouseConfiguration?.warehouseNameForShipper;
    }
    if (user?.role === 'PROVIDER' && customerWarehouseConfiguration?.warehouse?.reference) {
        return customerWarehouseConfiguration?.warehouse?.reference;
    }
    return `${customerWarehouseConfiguration?.warehouse?.address?.city} - ${customerWarehouseConfiguration?.warehouse?.address?.zipCode}`;
};

const getWarehouseLabel = (user, warehouse, defaultMessage) => {
    if (!warehouse) {
        return defaultMessage;
    }

    const customerWarehouseConfiguration = user?.customerWarehouseConfigurations?.find(
        (node) => node?.warehouseId === warehouse?.id
    );
    if (user?.role === 'SHIPPER' && customerWarehouseConfiguration?.warehouseNameForShipper) {
        return customerWarehouseConfiguration?.warehouseNameForShipper;
    }

    if (user?.role === 'PROVIDER' && warehouse.reference) {
        return warehouse.reference;
    }

    if (!warehouse.address) {
        return defaultMessage;
    }

    const { city, zipCode, name } = warehouse.address;
    return [city, zipCode, name].filter((value) => !!value).join(' - ');
};

const getWarehouseAddress = (warehouse, defaultMessage) => {
    return `${warehouse?.address?.addressLine1 ?? defaultMessage}, ${warehouse?.address?.zipCode ?? defaultMessage} ${
        warehouse?.address?.city ?? defaultMessage
    }`;
};

export { getWarehouseLabelFromConfiguration, getWarehouseLabel, getWarehouseAddress };
